import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import FRONTEND_CONFIG from "./frontend_config";

export default function ApplicantDashboard() {
  const [dashboardData, setDashboardData] = useState(null);
  const [showInstructions, setShowInstructions] = useState(false);

  // added 28-11-25 (your code)
  const [isExamAvailable, setIsExamAvailable] = useState(false);

  // NEW — exam expiry state
  const [isExamExpired, setIsExamExpired] = useState(false);

  // NEW — countdown timer
  const [timeLeft, setTimeLeft] = useState("");

  // NEW — webcam error message
  const [webcamError, setWebcamError] = useState(""); // 👈 ADDED

  const fieldsToShow = [
    "studentName",
    "fatherName",
    "applicationId",
    "gender",
    "currentClass",
    "previousSchool",
    "email",
    "contactNo",
    "dob",
    "address",
    "examDate",
    "status",
    "assignedQuestionSet",
  ];

  const navigate = useNavigate();

  useEffect(() => {
    const storedData = localStorage.getItem("dashboardData");
    if (storedData) {
      setDashboardData(JSON.parse(storedData));
    } else {
      navigate("/");
    }

    const startTime = new Date(FRONTEND_CONFIG.EXAM_START);
    const endTime = new Date(FRONTEND_CONFIG.EXAM_END);

    const updateTimer = () => {
      const now = new Date();

      if (now > endTime) {
        setIsExamAvailable(false);
        setIsExamExpired(true);
      } else {
        const available = now >= startTime && now <= endTime;
        setIsExamAvailable(available);
        setIsExamExpired(false);
      }

      if (now < startTime) {
        const diff = startTime - now;
        if (diff > 0) {
          const h = Math.floor(diff / (1000 * 60 * 60));
          const m = Math.floor((diff / (1000 * 60)) % 60);
          const s = Math.floor((diff / 1000) % 60);
          setTimeLeft(`${h}h : ${m}m : ${s}s`);
        } else {
          setTimeLeft("00h : 00m : 00s");
        }

        if (diff <= 1000 && diff > -2000) {
          playAlertSound();
          setShowInstructions(true);
        }
      } else {
        setTimeLeft("");
      }
    };

    const interval = setInterval(updateTimer, 1000);
    updateTimer();

    return () => clearInterval(interval);
  }, [navigate]);

  const playAlertSound = () => {
    const audio = new Audio(
      "data:audio/wav;base64,UklGRiQAAABXQVZFZm10IBAAAAABAAEAESsAACJWAAACABAAZGF0YQgAAAAA/////w=="
    );
    audio.play().catch(() => {});
  };

  if (!dashboardData) {
    return <p>Loading dashboard...</p>;
  }

  const handleLogout = () => {
    localStorage.removeItem("dashboardData");
    navigate("/");
  };

  // ======================= 📸 WEBCAM CHECK ADDED ===========================
  const checkWebcam = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });
      stream.getTracks().forEach((t) => t.stop());
      return true;
    } catch (err) {
      return false;
    }
  };

  const handleStartExamClick = async () => {
    setWebcamError("");

    // 🔍 Check before showing instruction modal
    const cam = await checkWebcam();

    if (!cam) {
      setWebcamError("❌ Please enable your webcam to start the exam.");
      return;
    }

    setShowInstructions(true);
  };
  // ========================================================================

  const startExamNow = () => {
    navigate("/exam", { state: { dashboardData } });
  };

  return (
    <div
      className="dashboard-container"
      style={{
        padding: "30px",
        position: "relative",
        minHeight: "100vh",
        backgroundColor: "#f0f4f8",
      }}
    >
      {/* Logout */}
      <button
        onClick={handleLogout}
        style={{
          position: "absolute",
          top: "20px",
          right: "20px",
          backgroundColor: "#dc3545",
          color: "#fff",
          padding: "8px 14px",
          border: "none",
          borderRadius: "6px",
          cursor: "pointer",
          fontWeight: "bold",
        }}
      >
        Logout
      </button>

      <h1 style={{ marginBottom: "20px", textAlign: "center" }}>
        Welcome, {dashboardData.studentName} 👋
      </h1>

      <div
        style={{
          maxWidth: "650px",
          margin: "0 auto",
          backgroundColor: "#fff",
          padding: "25px",
          borderRadius: "12px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        }}
      >
        <h2
          style={{
            textAlign: "center",
            marginBottom: "15px",
            color: "#333",
          }}
        >
          Applicant Details
        </h2>

        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            fontSize: "15px",
          }}
        >
          <tbody>
            {fieldsToShow.map((key) => (
              <tr key={key}>
                <td
                  style={{
                    textTransform: "capitalize",
                    fontWeight: "bold",
                    padding: "8px",
                    borderBottom: "1px solid #ddd",
                    width: "40%",
                    color: "#555",
                  }}
                >
                  {key.replace(/([A-Z])/g, " $1")}
                </td>

                <td
                  style={{
                    padding: "8px",
                    borderBottom: "1px solid #ddd",
                    color: "#333",
                  }}
                >
                  {dashboardData[key] || "—"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* Countdown Timer */}
        {!isExamAvailable && !isExamExpired && timeLeft && (
          <div
            style={{
              marginTop: "15px",
              padding: "12px",
              backgroundColor: "#ffe9c4",
              borderRadius: "8px",
              textAlign: "center",
              fontWeight: "bold",
              color: "#8a5600",
            }}
          >
            Exam starts in: {timeLeft}
          </div>
        )}

        <button
          onClick={handleStartExamClick}
          disabled={!isExamAvailable}
          style={{
            marginTop: "25px",
            width: "100%",
            backgroundColor: isExamAvailable ? "#007bff" : "#9bb7d4",
            color: "#fff",
            padding: "12px",
            border: "none",
            borderRadius: "8px",
            cursor: isExamAvailable ? "pointer" : "not-allowed",
            fontSize: "16px",
            fontWeight: "bold",
          }}
        >
          {isExamAvailable
            ? "Start Exam"
            : isExamExpired
            ? "Exam Time Over"
            : "Exam Not Available Yet"}
        </button>

        {/* ❌ Webcam error message */}
        {webcamError && (
          <p style={{ color: "red", textAlign: "center", marginTop: "10px" }}>
            {webcamError}
          </p>
        )}
      </div>

      {/* ====================== INSTRUCTION MODAL ====================== */}
      {showInstructions && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              width: "450px",
              backgroundColor: "#fff",
              padding: "25px",
              borderRadius: "12px",
              boxShadow: "0 6px 20px rgba(0,0,0,0.2)",
            }}
          >
            <h2 style={{ marginBottom: "15px", textAlign: "center" }}>
              Exam Instructions
            </h2>

            <ul
              style={{
                textAlign: "left",
                lineHeight: "1.8",
                marginBottom: "20px",
              }}
            >
              <li>📌 Do not refresh or close or switch the window during the exam.</li>
              <li>📌 Once submitted, you cannot change your answers.</li>
              <li>📌 Timer will start immediately after clicking start.</li>
              <li>📌 Maintain stable internet connection.</li>
            </ul>

            <button
              onClick={startExamNow}
              style={{
                width: "100%",
                backgroundColor: "#28a745",
                color: "#fff",
                padding: "12px",
                border: "none",
                borderRadius: "8px",
                cursor: "pointer",
                fontSize: "16px",
                fontWeight: "bold",
              }}
            >
              I Understand, Start Exam
            </button>

            <button
              onClick={() => setShowInstructions(false)}
              style={{
                width: "100%",
                marginTop: "10px",
                backgroundColor: "#6c757d",
                color: "#fff",
                padding: "10px",
                border: "none",
                borderRadius: "8px",
                cursor: "pointer",
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      )}
      {/* ================================================================ */}
    </div>
  );
}
